var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4445 4.55005C42.7641 4.55005 46.2659 8.23013 46.2659 12.7695C46.2659 17.3068 42.7676 20.9858 38.4496 20.989C34.131 20.9858 30.6312 17.3078 30.6281 12.7695H30.623C30.623 8.23013 34.1244 4.55005 38.4445 4.55005Z",
    fill: "url(#paint0_linear_7801_46831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1305 0.695679H16.8963H16.8303C16.6032 0.730371 16.3965 0.849927 16.2462 1.03193L15.9567 1.30413C15.9308 1.45571 15.9171 1.60943 15.9161 1.76314C15.9161 3.57249 17.846 3.75396 17.846 3.75396C18.9573 4.03043 19.7217 5.10163 19.6643 6.29986C19.6653 6.51869 19.6429 6.73699 19.5982 6.95101C19.4301 7.29687 19.3397 7.67796 19.3341 8.06651C19.3341 9.49158 20.8578 9.97727 20.8578 9.97727C21.6862 10.3776 22.2128 11.2508 22.2037 12.2083C22.2027 12.6497 22.1143 13.0857 21.9447 13.4892C21.6328 13.8815 21.4541 14.3715 21.4368 14.8823C21.4368 16.0565 22.6151 16.7236 22.6151 16.7236C23.1849 17.1832 23.5232 17.8904 23.5344 18.6451C23.5166 19.2706 23.3221 19.8759 22.9757 20.385C22.483 20.7581 22.1813 21.3484 22.158 21.9862C22.2093 22.647 22.5023 23.2608 22.9757 23.6995C23.3332 24.1494 23.5359 24.7141 23.5496 25.3007C23.5171 26.097 23.1819 26.8469 22.6202 27.3823C21.9396 27.671 21.4866 28.3569 21.4673 29.1276C21.4891 29.6666 21.6669 30.186 21.9751 30.6167C22.157 31.0004 22.2555 31.4215 22.2646 31.8496C22.2646 33.344 20.8883 34.1393 20.8883 34.1393C19.6693 34.5236 19.3646 35.3402 19.3646 36.0287C19.3707 36.4221 19.4499 36.8101 19.5982 37.1709C19.6587 37.4207 19.6897 37.6763 19.6897 37.9341C19.6897 39.8129 17.846 40.384 17.846 40.384C16.2005 40.496 15.9161 41.6809 15.9161 42.4282C15.915 42.6182 15.9318 42.8076 15.9668 42.9939L16.2259 43.2394C16.3965 43.4065 16.6103 43.5164 16.8404 43.5543H37.1355C43.542 43.5767 48.7529 38.1375 48.7743 31.4045C48.7854 27.829 47.3024 24.4286 44.7183 22.1037C49.565 17.7057 50.1019 10.0114 45.9169 4.9175C43.7142 2.23603 40.5099 0.695679 37.1401 0.695679C37.1361 0.695679 37.1335 0.695679 37.1305 0.695679ZM37.8314 4.34652C42.151 4.34652 45.6529 8.0266 45.6529 12.566C45.6529 17.1032 42.1545 20.7823 37.8365 20.7855C33.5179 20.7823 30.0181 17.1043 30.015 12.566H30.01C30.01 8.0266 33.5113 4.34652 37.8314 4.34652Z",
    fill: "url(#paint1_linear_7801_46831)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.739 12.5069C40.739 11.0274 39.5776 9.82825 38.1449 9.82825C37.6625 9.82825 37.2109 9.96416 36.8241 10.2009C37.0206 10.3821 37.1443 10.6456 37.1443 10.939C37.1443 11.4853 36.7155 11.9281 36.1864 11.9281C35.9889 11.9281 35.8053 11.8663 35.6528 11.7605C35.5864 11.9974 35.5508 12.2479 35.5508 12.5069C35.5508 13.9864 36.7121 15.1856 38.1449 15.1856C39.5776 15.1856 40.739 13.9864 40.739 12.5069Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2307 26.9878L57.2739 24.8151L59.5641 9.72351L63.8802 6.17082",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7673 26.9877L12.7241 24.8149L10.434 9.72338L6.1179 6.1707",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7801_46831",
    x1: 50.2427,
    y1: 8.68227,
    x2: 42.0693,
    y2: 0.729766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7801_46831",
    x1: 16.236,
    y1: 0.333822,
    x2: 16.236,
    y2: 42.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600DB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFeed);
export default __webpack_public_path__ + "static/media/empty-feed.09e7de82.svg";
export { ForwardRef as ReactComponent };